// Cowtown Sticker Co. - Custom Sticker Configurator Engine

(function () {
  const COPY = window.CowtownConfiguratorCopy || {};

  // State variables
  let state = {
    productType: null,
    width: null,
    height: null,
    finish: 'gloss',
    material: 'standard',
    laminate: 'gloss',
    bannerEdge: 'trimmed',
    signSides: 'single',
    grommetCount: 0,
    grommetSide: 'top',
    borderStyle: 'white-medium',
    borderColor: 'white',
    borderWidth: 'medium',
    cutShape: 'artwork',
    cutShapeTouched: false,
    quantity: null,
    zoom: 1.0,
    artworkRotation: 0,
    lockProportions: true,
    artworkRatio: 1,
    imageObj: null,
    imageName: 'Artwork to be emailed',
    artworkSource: 'none',
    materialTouched: false,
    laminateTouched: false,
    bleedTouched: false,
    sheetNotes: '',
    requestProof: false,
    spotWhite: false, spotWhiteMode: 'upload', maskImage: null, maskFile: null
  };
  let artworkRevision=0;
  let contourMaskCache={key:'',mask:null,opacity:null};

  // Visible format names/descriptions are read from Theme Editor-driven DOM data attributes.


  // Sticker estimates use quarter-square-inch bands through 36, then whole inches.
  // Checkout requires an existing Shopify variant with the exact matching price.
  const PRICING_AREA_INCREMENT = 0.25;
  const PRICING_RULES = Object.freeze({
    'glitter': Object.freeze({ ratePerSqIn: 0.07, minimumUnit: 0.35 }),
    'glitter-kiss-cut': Object.freeze({ ratePerSqIn: 0.08, minimumUnit: 0.40 }),
    'chrome': Object.freeze({ ratePerSqIn: 0.11, minimumUnit: 0.55 }),
    'chrome-kiss-cut': Object.freeze({ ratePerSqIn: 0.12, minimumUnit: 0.60 }),
    'die-cut': Object.freeze({ ratePerSqIn: 0.05, minimumUnit: 0.25 }),
    'kiss-cut': Object.freeze({ ratePerSqIn: 0.06, minimumUnit: 0.3 }),
    'holographic': Object.freeze({ ratePerSqIn: 0.07, minimumUnit: 0.35 }),
    'holographic-kiss-cut': Object.freeze({ ratePerSqIn: 0.08, minimumUnit: 0.4 }),
    'bumper-decal': Object.freeze({ ratePerSqIn: 0.09, minimumUnit: 0.45 }),
    'heavy-duty-kiss-cut': Object.freeze({ ratePerSqIn: 0.1, minimumUnit: 0.5 }),
    'sticker-sheet': Object.freeze({ ratePerSqIn: 0.045, minimumUnit: 0.23 })
  });

  function snapAreaUp(areaSqIn) {
    const safeArea = Math.max(PRICING_AREA_INCREMENT, Number(areaSqIn) || 0);
    if(safeArea>36+1e-9)return Math.ceil(safeArea-1e-9);
    return Number((Math.ceil((safeArea - 1e-9) / PRICING_AREA_INCREMENT) * PRICING_AREA_INCREMENT).toFixed(2));
  }

  function getPricingRule(productType, finish) {
    if(productType==='sticker-sheet')return PRICING_RULES['sticker-sheet'];
    if(['glitter','chrome'].includes(state.material))return PRICING_RULES[state.material+(productType==='kiss-cut'?'-kiss-cut':'')];
    // Preserve the working Pass 4 behavior where selecting holographic finish
    // moves a standard die/kiss cut into the matching holographic rate.
    if (finish === 'holographic') {
      if (productType === 'kiss-cut') return PRICING_RULES['holographic-kiss-cut'];
      if (productType === 'die-cut') return PRICING_RULES['holographic'];
    }
    if(state.material==='industrial')return PRICING_RULES[productType==='kiss-cut'?'heavy-duty-kiss-cut':'bumper-decal'];
    return PRICING_RULES[productType] || PRICING_RULES['die-cut'];
  }

  function quantityMultiplierFor(quantity) {
    if (quantity >= 5000) return 0.58;
    if (quantity >= 2500) return 0.65;
    if (quantity >= 1000) return 0.72;
    if (quantity >= 500) return 0.80;
    if (quantity >= 250) return 0.90;
    if (quantity >= 100) return 1.00;
    if (quantity >= 50) return 1.25;
    if (quantity >= 25) return 1.50;
    return 1.75;
  }

  function calculateStickerPrice(width, height, quantity, productType, finish) {
    const actualSqInches = Math.max(PRICING_AREA_INCREMENT, width * height);
    const pricingSqInches = snapAreaUp(actualSqInches);
    const rule = getPricingRule(productType, finish);
    const quantityMultiplier = quantityMultiplierFor(quantity);

    const computedUnitPrice = pricingSqInches * rule.ratePerSqIn * quantityMultiplier;
    const unitPrice = Math.max(rule.minimumUnit, computedUnitPrice);
    // Preserve the three half-cent rounding results in the merchant's source CSV.
    const csvTotals = {'0.045|30.25|5000':3947.62,'0.045|33.25|5000':4339.12,'0.045|35.25|5000':4600.12};
    const laminatedTotal = csvTotals[[rule.ratePerSqIn,pricingSqInches,quantity].join('|')] ?? Math.round((unitPrice * quantity + 1e-9) * 100) / 100;
    const priceFactor=isUnlaminated()?0.9:1;
    const totalPrice=Math.round((laminatedTotal*priceFactor+1e-9)*100)/100;
    const finalUnitPrice = Number((totalPrice / quantity).toFixed(2));

    const qty10UnitPrice = Math.max(rule.minimumUnit, pricingSqInches * rule.ratePerSqIn * 1.75);
    const savingsPercent = Math.max(0, Math.round((1 - (finalUnitPrice / (qty10UnitPrice*priceFactor))) * 100));

    return {
      unitPrice: finalUnitPrice,
      totalPrice,
      savingsPercent,
      sqInches: actualSqInches,
      pricingSqInches,
      ratePerSqIn: rule.ratePerSqIn,
      minimumUnit: rule.minimumUnit
    };
  }


  let unlaminatedAccepted=false;
  function isUnlaminated(){return ['die-cut','kiss-cut','sticker-sheet'].includes(state.productType)&&state.laminate==='none';}
  function acknowledgeUnlaminated(){
    if(!isUnlaminated()||unlaminatedAccepted)return Promise.resolve(true);
    const dialog=document.getElementById('UnlaminatedDialog');
    if(dialog.open)return Promise.resolve(false);
    return new Promise(resolve=>{
      const finish=accepted=>{unlaminatedAccepted=accepted;dialog.close();resolve(accepted);};
      document.getElementById('AcceptUnlaminated').onclick=()=>finish(true);
      document.getElementById('CancelUnlaminated').onclick=()=>finish(false);
      dialog.oncancel=event=>{event.preventDefault();finish(false);};
      dialog.showModal();
    });
  }
  function usesUnitQuantities() { return ['banner','yard-sign','photo-paper'].includes(state.productType); }
  let maskRevision=0;
  function spotWhiteActive(){return state.spotWhite&&['holographic','glitter'].includes(state.material)&&['die-cut','kiss-cut','sticker-sheet'].includes(state.productType);}
  function syncSpotWhite(){
    const active=spotWhiteActive(),setup=active&&state.spotWhiteMode==='setup';
    const set=(id,property,value)=>{const el=document.getElementById(id);if(el)el[property]=value;};
    set('SpotWhiteEnabled','checked',state.spotWhite);set('SpotWhiteDetails','hidden',!active);set('SpotWhiteMode','value',state.spotWhiteMode);set('SpotWhiteUploadFields','hidden',setup);set('SpotWhiteSetupFields','hidden',!setup);
    for(const id of ['SpotWhiteDescription','SpotWhiteFeeAccepted','SpotWhiteName','SpotWhiteEmail','SpotWhitePhone','SpotWhiteBestTime']){set(id,'required',setup);set(id,'disabled',!setup);}
    set('SpotWhiteFile','disabled',!active||setup);
  }
  function clearWhiteMask(){maskRevision++;state.maskImage=null;state.maskFile=null;const input=document.getElementById('SpotWhiteFile');if(input)input.value='';const status=document.getElementById('SpotWhiteStatus');if(status)status.textContent='Select a mask matching the current artwork. Files are selected for preview; delivery is confirmed when you continue.';}
  window.setSpotWhite=function(value){state.spotWhite=!!value;syncSpotWhite();updatePriceDisplay();renderCanvas();};
  window.setSpotWhiteMode=function(value){state.spotWhiteMode=value==='setup'?'setup':'upload';syncSpotWhite();updatePriceDisplay();renderCanvas();};
  window.setRequestProof=function(value){state.requestProof=!!value;updatePriceDisplay();};
  window.renderSpotWhiteOverlay=function(){renderCanvas();};
  window.handleWhiteMaskUpload=function(event){
    const file=event.target.files?.[0];clearWhiteMask();const status=document.getElementById('SpotWhiteStatus');
    if(!file)return;
    if(!state.imageObj){status.textContent='Select the color artwork before its mask.';return;}
    if(!/\.png$/i.test(file.name)||file.size===0||file.size>25*1024*1024){status.textContent='Choose a non-empty PNG up to 25 MB. Email larger files separately.';return;}
    const revision=maskRevision,artwork=state.imageObj,reader=new FileReader();
    reader.onerror=()=>{if(revision===maskRevision)status.textContent='The mask file could not be read. Try another PNG.';};
    reader.onload=()=>{const image=new Image();image.onerror=()=>{if(revision===maskRevision)status.textContent='This file could not be decoded as an image. Export a PNG mask.';};image.onload=()=>{
      if(revision!==maskRevision||state.imageObj!==artwork)return;
      if(image.naturalWidth!==artwork.naturalWidth||image.naturalHeight!==artwork.naturalHeight){status.textContent=`Mask must be ${artwork.naturalWidth} × ${artwork.naturalHeight} pixels to match the artwork. Selected: ${image.naturalWidth} × ${image.naturalHeight}.`;return;}
      const preview=document.createElement('canvas'),scale=Math.min(1,600/Math.max(image.naturalWidth,image.naturalHeight));preview.width=Math.max(1,Math.round(image.naturalWidth*scale));preview.height=Math.max(1,Math.round(image.naturalHeight*scale));const context=preview.getContext('2d',{willReadFrequently:true});context.drawImage(image,0,0,preview.width,preview.height);
      const data=context.getImageData(0,0,preview.width,preview.height).data;let covered=false;for(let i=3;i<data.length;i+=4)if(data[i]){covered=true;break;}if(!covered){status.textContent='This mask is fully transparent and identifies no white-ink coverage.';return;}
      context.globalCompositeOperation='source-in';context.fillStyle='#22d3ee';context.fillRect(0,0,preview.width,preview.height);state.maskImage=preview;state.maskFile=file;status.textContent=`${file.name}: dimensions match. Cyan shows requested white-ink coverage, not final printed color. Selected for preview. File delivery will be confirmed when you continue.`;
      document.getElementById('configurator')?.dispatchEvent(new CustomEvent('cowtown:white-mask-selected',{detail:{file,width:image.naturalWidth,height:image.naturalHeight,artworkName:state.imageName},bubbles:true}));renderCanvas();updatePriceDisplay();
    };image.src=reader.result;};reader.readAsDataURL(file);
  };
  function validateSpotWhite(){
    if(!spotWhiteActive())return true;
    if(state.spotWhiteMode==='upload'){if(state.maskFile)return true;const status=document.getElementById('SpotWhiteStatus');status.textContent='A matching mask is required. Select one, or choose the $20 first-file setup service.';document.getElementById('SpotWhiteFile').focus();return false;}
    for(const id of ['SpotWhiteDescription','SpotWhiteFeeAccepted','SpotWhiteName','SpotWhiteEmail','SpotWhitePhone','SpotWhiteBestTime']){const el=document.getElementById(id);if(!el.checkValidity()){el.reportValidity();return false;}}return true;
  }
  function spotWhiteQuote(){
    if(!spotWhiteActive())return '';
    if(state.spotWhiteMode==='setup')return 'White-mask setup requested: $20 for the first file needing setup and $5 for each additional file in the same order, included in this estimate. Customer acknowledged the $20 first-file setup fee and payment-before-modifications policy. File review may take place first; no artwork modifications until the setup fee invoice is paid. This request does not confirm payment.\nMask instructions: '+document.getElementById('SpotWhiteDescription').value+'\n';
    return 'Spot white requested. Mask preview file: '+(state.maskFile?.name||'not selected')+'. File selected locally only; artwork and mask must be emailed separately.\n';
  }

  function isSignOrBanner() { return ['banner','yard-sign'].includes(state.productType); }
  function rollRunPrice(width,height,quantity,rollWidth,pricePerLinearFoot,minimumRunPrice=0) {
    const across=Math.max(1,Math.floor((rollWidth+1e-9)/height));
    const runs=Math.ceil(quantity/across);
    const linearFeet=width/12*runs;
    const print=Number(Math.max(minimumRunPrice,linearFeet*pricePerLinearFoot).toFixed(2));
    return {across,runs,linearFeet:Number(linearFeet.toFixed(2)),print};
  }
  function bannerPrice(width,height,quantity,edge,grommets) {
    const rollWidth=Math.max(1,Number(COPY.bannerRollWidth)||48);
    const rate=edge==='sealed'?Math.max(0,Number(COPY.bannerSealedLinearRate)||15):Math.max(0,Number(COPY.bannerTrimmedLinearRate)||10);
    const run=rollRunPrice(width,height,quantity,rollWidth,rate,Math.max(0,Number(COPY.bannerMinimum)||15));
    const hardware=Number((grommets*.5*quantity).toFixed(2)),hem=0,totalPrice=Number((run.print+hardware).toFixed(2));
    return {...run,unitPrice:Number((totalPrice/quantity).toFixed(2)),totalPrice,hem,hardware,area:width*height*quantity/144,rollWidth,rate};
  }
  function photoPrintPrice(width,height,quantity) {
    const rollWidth=Math.max(1,Number(COPY.photoRollWidth)||28);
    const materialCost=Math.max(0,Number(COPY.photoMaterialCost)||1);
    const margin=Math.min(99.9,Math.max(0,Number(COPY.photoMarginPercent)||91.4))/100;
    const sellingRate=materialCost/(1-margin);
    const run=rollRunPrice(width,height,quantity,rollWidth,sellingRate,Math.max(0,Number(COPY.photoMinimum)||10));
    return {...run,unitPrice:Number((run.print/quantity).toFixed(2)),totalPrice:run.print,area:width*height*quantity/144,rollWidth,materialCost,marginPercent:margin*100,rate:sellingRate};
  }
  function texturedRate(){const narrow=['holographic','glitter'].includes(state.material);return Number(narrow?(COPY.texturedRate30??0.05):(COPY.texturedRate??0.02))||0;}
  function currentEstimate() {
    if(state.productType==='photo-paper')return photoPrintPrice(state.width,state.height,state.quantity);
    if(state.productType==='banner')return bannerPrice(state.width,state.height,state.quantity,state.bannerEdge,state.grommetCount);
    if(state.productType==='yard-sign'){const unitPrice=state.signSides==='double'?20:15;return {unitPrice,totalPrice:unitPrice*state.quantity};}
    const p=calculateStickerPrice(state.width,state.height,state.quantity,state.productType,state.finish);
    const rate=texturedRate();
    if(state.laminate==='heavy-duty'&&rate>0){p.laminateAddon=Number((state.width*state.height*state.quantity*rate).toFixed(2));p.totalPrice=Number((p.totalPrice+p.laminateAddon).toFixed(2));p.unitPrice=Number((p.totalPrice/state.quantity).toFixed(2));}
    if(spotWhiteActive()&&state.spotWhiteMode==='setup'){p.setupFee=20;p.totalPrice=Number((p.totalPrice+20).toFixed(2));}
    return p;
  }
  function pricingHandle(pricing) {
    const base=SHOPIFY_PRODUCT_HANDLES[effectivePricingProductType()];
    if(pricing.pricingSqInches<=36)return isUnlaminated()?base+'-unlaminated':base;
    if(isUnlaminated())return null; // Larger unlaminated runs need an email quote until priced range products exist.
    let ranges=[];try{ranges=JSON.parse(COPY.largeAreaProducts||'[]')}catch(_){}
    const match=Array.isArray(ranges)&&ranges.find(r=>r.class===base&&pricing.pricingSqInches>=Number(r.min)&&pricing.pricingSqInches<=Number(r.max));
    return match&&typeof match.handle==='string'?match.handle:null;
  }
  function requiresQuote() {
    if(spotWhiteActive())return true;
    if(!['die-cut','kiss-cut'].includes(state.productType))return true;
    if(!['standard','holographic','industrial','glitter','chrome'].includes(state.material))return true;
    if(state.laminate==='heavy-duty')return true;
    return !pricingHandle(currentEstimate());
  }
  function bleedWidthOptions(){
    return state.productType==='kiss-cut'
      ? [{name:'thin',value:.02},{name:'medium',value:.06},{name:'thick',value:.10}]
      : [{name:'thin',value:.08},{name:'medium',value:.14},{name:'thick',value:.20}];
  }
  function selectedBleedWidth(){return bleedWidthOptions().find(option=>option.name===state.borderWidth)?.value||0;}
  function syncProductOptions() {
    const vinyl = ['die-cut', 'kiss-cut', 'sticker-sheet'].includes(state.productType);
    const visibility = {WhiteBackgroundNote:usesUnitQuantities(),SpotWhiteOptions:['holographic','glitter'].includes(state.material)&&vinyl,YardSignOptions:state.productType==='yard-sign',UnitQuantityOptions:usesUnitQuantities(),StickerQuantityOptions:!usesUnitQuantities(),StickerPresets:!isSignOrBanner(),SheetQuoteNote:state.productType==='sticker-sheet',StickerSheetNotes:state.productType==='sticker-sheet'&&state.laminateTouched,CutOptions:['die-cut','kiss-cut'].includes(state.productType),CutShapeOptions:state.productType==='die-cut',VinylOptions:vinyl,BleedOptions:['die-cut','kiss-cut'].includes(state.productType)&&state.laminateTouched,FinishOptions:vinyl&&state.materialTouched,BannerOptions:state.productType==='banner',PhotoPaperNote:state.productType==='photo-paper',ChromeLaminateNote:vinyl&&state.material==='chrome'};
    Object.entries(visibility).forEach(([id,visible]) => { const el=document.getElementById(id); if(el) el.hidden=!visible; });
    const material=document.getElementById('MaterialSelect');if(material)material.value=state.material;
    const borderColor=document.getElementById('BorderColorSelect');if(borderColor)borderColor.value=state.borderColor;
    const borderWidth=document.getElementById('BorderWidthSelect');if(borderWidth)borderWidth.value=state.borderWidth;
    const shape=document.getElementById('CutShapeSelect');if(shape)shape.value=state.cutShape;
    const cutBleedTitle=document.getElementById('CutBleedSectionTitle');if(cutBleedTitle)cutBleedTitle.textContent=state.productType==='kiss-cut'?'Bleed':'Cut shape & bleed';
    const bleedWidths=bleedWidthOptions(),bleedWidthValue=selectedBleedWidth()||bleedWidths[1].value;
    const bleedWidthDisplay=document.getElementById('BorderWidthDisplay');if(bleedWidthDisplay){bleedWidthDisplay.value=bleedWidthValue.toFixed(2)+'″';bleedWidthDisplay.textContent=bleedWidthValue.toFixed(2)+'″';}
    const bleedWidthRange=document.getElementById('BleedWidthRange');if(bleedWidthRange){bleedWidthRange.min=bleedWidths[0].value;bleedWidthRange.max=bleedWidths[2].value;bleedWidthRange.step=(bleedWidths[1].value-bleedWidths[0].value).toFixed(2);bleedWidthRange.value=bleedWidthValue.toFixed(2);}
    const setBleedLabel=(id,value)=>{const label=document.getElementById(id);if(label)label.textContent=value.toFixed(2)+'″';};
    setBleedLabel('BleedMinLabel',bleedWidths[0].value);setBleedLabel('BleedMidLabel',bleedWidths[1].value);setBleedLabel('BleedMaxLabel',bleedWidths[2].value);
    document.querySelectorAll('.config-cut-shape-btn').forEach(button=>{const selected=button.dataset.shape===state.cutShape;button.classList.toggle('is-selected',selected);button.setAttribute('aria-pressed',String(selected));});
    document.querySelectorAll('.config-bleed-color-btn').forEach(button=>{const selected=button.dataset.color===state.borderColor;button.classList.toggle('is-selected',selected);button.setAttribute('aria-pressed',String(selected));});
    const lock=document.getElementById('LockProportionsInput');if(lock)lock.checked=state.lockProportions||(state.productType==='die-cut'&&state.cutShape==='circle');
    if(lock)lock.disabled=state.productType==='sticker-sheet'||isSignOrBanner()||(state.productType==='die-cut'&&state.cutShape==='circle');
    syncSpotWhite();
    if(state.material === 'chrome') state.laminate='gloss';
    const noticeNone=document.getElementById('UnlaminatedNotice');if(noticeNone)noticeNone.hidden=!isUnlaminated();
    const select=document.getElementById('FinishSelect');
    if(select) { select.value=state.laminateTouched?state.laminate:''; select.disabled=state.material==='chrome'; }
    state.finish=state.material==='holographic' ? 'holographic' : state.laminate;
    const description=document.getElementById('MaterialDescription');
    if(description) description.innerText=['holographic','glitter'].includes(state.material) ? 'Flexible vinyl with a specialty effect — not foil.' : '';
    const notice=document.getElementById('FormatNoticeText');
    if(notice) notice.innerText=requiresQuote() ? 'This selection is available by email quote.' : 'Choose your material, laminate, and finished size.';
    const materialSection=document.getElementById('ConfiguratorMaterialSection');
    const bleedSection=document.getElementById('BleedOptions');
    const finishSection=document.getElementById('FinishOptions');
    if(materialSection) materialSection.hidden=!vinyl;
    if(bleedSection)bleedSection.hidden=!(['die-cut','kiss-cut'].includes(state.productType)&&state.laminateTouched);
    if(finishSection && vinyl && state.materialTouched) finishSection.hidden=false;
    if(finishSection && !vinyl) finishSection.hidden=true;
  }
  function syncFormatChoices(formatId) {
    const buttons=[...document.querySelectorAll('.config-format-btn')];
    buttons.forEach(btn=>btn.classList.toggle('is-unselected',Boolean(formatId)&&btn.dataset.format!==formatId));
  }
  function syncMaterialChoices(materialId) {
    const buttons=[...document.querySelectorAll('.config-material-btn')];
    buttons.forEach(btn=>btn.classList.toggle('is-unselected',Boolean(materialId)&&btn.dataset.material!==materialId));
  }
  function syncMenuSelections() {
    const set=(id,value)=>{const el=document.getElementById(id);if(el)el.textContent=value;};
    const product=document.querySelector('.config-format-btn[data-format="'+state.productType+'"]')?.dataset.formatName || state.productType;
    const material=document.getElementById('MaterialSelect')?.selectedOptions?.[0]?.text || state.material;
    const finish=document.getElementById('FinishSelect')?.selectedOptions?.[0]?.text || state.laminate;
    set('ProductSectionSelection',['die-cut','kiss-cut','sticker-sheet'].includes(state.productType) ? product+(state.materialTouched?' · '+material:'') : product);
    set('MaterialSectionSelection',state.materialTouched?material:'');
    const shapeLabel={artwork:'Smooth contour',circle:'Circle',rectangle:'Square corners',rounded:'Rounded corners'}[state.cutShape]||'';
    set('BleedSectionSelection',state.borderColor&&state.borderWidth ? shapeLabel+' · '+state.borderColor+' · '+selectedBleedWidth().toFixed(2)+'″' : shapeLabel);
    set('FinishSectionSelection',state.laminateTouched?finish:'');
    set('DimensionSectionSelection',Number.isFinite(state.width)&&Number.isFinite(state.height)&&Number.isFinite(state.quantity) ? state.width.toFixed(2)+'″ × '+state.height.toFixed(2)+'″ · Qty '+state.quantity : '');
    set('QuantitySectionSelection','Qty '+state.quantity);
  }
  window.updateMaterial=function(value) {
    const materialSection=document.getElementById('ConfiguratorMaterialSection');
    if(state.materialTouched&&state.material===value){
      const choicesAreCompact=[...document.querySelectorAll('.config-material-btn')].some(button=>button.classList.contains('is-unselected'));
      syncMaterialChoices(choicesAreCompact?null:value);
      if(materialSection)materialSection.open=true;
      return;
    }
    const defaultBorderWidth=state.productType==='kiss-cut'?'thin':'medium';
    state.material=value; state.materialTouched=true; state.laminateTouched=false; state.bleedTouched=false; state.borderStyle='white-'+defaultBorderWidth;state.borderColor='white';state.borderWidth=defaultBorderWidth;state.cutShapeTouched=false; syncProductOptions();
    const finishSection=document.getElementById('FinishOptions');
    if(materialSection) materialSection.open=false;
    if(finishSection && !finishSection.hidden) finishSection.open=true;
    document.querySelectorAll('.config-material-btn').forEach(btn=>{
      btn.className='config-material-btn p-3 rounded-xl border text-left text-xs '+(btn.dataset.material===value?'bg-amber-500/10 border-amber-500 text-slate-100':'border-slate-800 bg-slate-900 text-slate-300 hover:border-slate-700');
    });
    syncMaterialChoices(value);
    if(value==='chrome'){window.updateStickerFinish('gloss');return;}
    updatePriceDisplay(); renderCanvas();
  };
  window.selectConfigMaterial=function(value){
    if(['standard','holographic','glitter','industrial','chrome'].includes(value))window.updateMaterial(value);
  };
  window.revealMaterialOptions=function(){state.materialTouched=true;syncProductOptions();};
  window.updateBannerEdge=function(value){state.bannerEdge=value;updatePriceDisplay();};
  window.updateSignSides=function(value){state.signSides=value==='double'?'double':'single';updatePriceDisplay();};
  window.setStickerSheetNotes=function(value){state.sheetNotes=String(value||'').slice(0,1500);};
  window.continueFromStickerSheetNotes=function(){
    const dimensionsSection=document.getElementById('ConfiguratorDimensionsSection');
    if(dimensionsSection)dimensionsSection.open=true;
  };
  window.updateGrommets=function(count,side) {
    if(count!==null && [0,2,4,6,8,10].includes(Number(count)))state.grommetCount=Number(count);
    if(side && ['top','right','bottom','left'].includes(side))state.grommetSide=side;
    updatePriceDisplay();
    const sideControl=document.getElementById('GrommetSideField');
    if(sideControl)sideControl.hidden=state.grommetCount!==2;
    renderCanvas();
  };
  function grommetPositions(width,height,count,side) {
    if(!count)return [];
    const left=1,right=width-1,top=1,bottom=height-1;
    const corners=[[left,top],[right,top],[right,bottom],[left,bottom]];
    if(count===2)return {top:[corners[0],corners[1]],right:[corners[1],corners[2]],bottom:[corners[3],corners[2]],left:[corners[0],corners[3]]}[side];
    const points=[...corners],longHorizontal=width>=height;
    const additions=count===6?[0.5]:count>=8?[1/3,2/3]:[];
    for(const t of additions){
      if(longHorizontal)points.push([left+(right-left)*t,top],[left+(right-left)*t,bottom]);
      else points.push([left,top+(bottom-top)*t],[right,top+(bottom-top)*t]);
    }
    if(count===10){
      if(longHorizontal)points.push([left,height/2],[right,height/2]);
      else points.push([width/2,top],[width/2,bottom]);
    }
    return points;
  }
  function drawBannerGrommets(ctx,x,y,ppi) {
    const points=grommetPositions(state.width,state.height,state.grommetCount,state.grommetSide);
    const invalid=points.length && (state.width<3 || state.height<3 || points.some((p,i)=>points.some((q,j)=>i!==j&&Math.hypot(p[0]-q[0],p[1]-q[1])<1)));
    const note=document.getElementById('GrommetPreviewNote');
    if(note)note.innerText=invalid ? 'Increase the banner size or reduce the grommet count: these 1-inch openings would overlap or extend beyond the edge.' : '1-inch opening previews; centers sit 1 inch inside each edge. Final placement is confirmed with your quote.';
    if(invalid)return;
    ctx.save();ctx.globalCompositeOperation='destination-out';
    for(const [gx,gy] of points){ctx.beginPath();ctx.arc(x+gx*ppi,y+gy*ppi,ppi/2,0,Math.PI*2);ctx.fill();}
    ctx.globalCompositeOperation='source-over';ctx.strokeStyle='#fbbf24';ctx.lineWidth=1.5;ctx.setLineDash([5,4]);
    for(const [gx,gy] of points){ctx.beginPath();ctx.arc(x+gx*ppi,y+gy*ppi,ppi/2,0,Math.PI*2);ctx.stroke();}
    ctx.restore();
  }
  window.requestCustomProductQuote = function () { requestConfigurationQuote(); };
  async function requestConfigurationQuote() {
    if(!await acknowledgeUnlaminated())return;
    if(!validateSpotWhite())return;
    const quantityInput=document.getElementById('CustomUnitQuantity');
    if(usesUnitQuantities()&&quantityInput&&quantityInput.validity&&!quantityInput.validity.valid){quantityInput.reportValidity();return;}
    let uploaded=[];const handoffId=crypto.randomUUID();
    if(artworkLoading||artworkLoadError){window.alert('Please wait for a valid artwork preview before continuing.');return;}
    try{await window.CowtownQuoteStorage.set({id:handoffId,configuration:{material:state.material,laminate:state.laminate,border:state.borderStyle,shape:state.cutShape,edge:state.bannerEdge,grommets:state.grommetCount,side:state.grommetSide,sides:state.signSides,artworkRotation:state.artworkRotation,sheetNotes:state.productType==='sticker-sheet'?state.sheetNotes:'',sheetSetupReview:state.productType==='sticker-sheet',requestProof:state.requestProof,maskSetup:spotWhiteActive()&&state.spotWhiteMode==='setup'},specs: [state.material,state.laminate,state.borderStyle,state.cutShape].filter(Boolean).join("; "),file:originalArtworkFile,previewUrl:originalArtworkFile?null:state.imageObj?.src,proportional:state.lockProportions,mask:spotWhiteActive()&&state.spotWhiteMode==='upload'?state.maskFile:null,name:state.imageName,format:state.productType,width:state.width,height:state.height,quantity:state.quantity,createdAt:Date.now()});}catch(error){window.alert('Your browser could not carry the artwork to the quote form. Please enable site storage or use Custom Orders to select your files there.');return;}
    const vinyl=!['banner','photo-paper','yard-sign'].includes(state.productType);
    const fulfillment=state.productType==='yard-sign'?'Printing: '+state.signSides+'; H-stake included; Local Pickup Only\n':'';
    const estimate=currentEstimate();
    const rollSummary=['banner','photo-paper'].includes(state.productType)?`Roll pricing: ${estimate.linearFeet.toFixed(2)} linear feet; ${estimate.across} item${estimate.across===1?'':'s'} fit across ${estimate.rollWidth.toFixed(0)}-inch media; ${estimate.runs} roll run${estimate.runs===1?'':'s'}.\n`:'';
    let details=`${spotWhiteQuote()}${fulfillment}Estimated total: ${'$'+estimate.totalPrice.toFixed(2)} (subject to confirmation)\nProduct: ${state.productType}\nMaterial: ${vinyl?state.material:'N/A'}\nLaminate: ${vinyl?state.laminate:'None'}\nProof preference: ${state.requestProof?'Customer proof requested — production waits for approval':'No customer proof requested — proceed after staff production review; contact customer if significant issues are found'}\nEdge: ${state.productType==='banner'?state.bannerEdge:'N/A'}\nSize: ${state.width.toFixed(2)} x ${state.height.toFixed(2)} inches\nQuantity: ${state.quantity}\n${rollSummary}Artwork rotation: ${state.artworkRotation} degrees clockwise\nArtwork name: ${state.imageName}\n${state.productType==='sticker-sheet'?`Sticker sheet customer notes: ${state.sheetNotes.trim()||'None provided'}\nSticker sheet setup: Review required; setup fee may be waived when production-ready files are emailed.\n`:''}${state.productType==='banner'?`Grommets: ${state.grommetCount}${state.grommetCount===2?' on '+state.grommetSide+' edge':''}; 1-inch centers from edges\n`:''}${vinyl?`Border: ${state.borderStyle}\nCut shape: ${state.cutShape}\n`:''}Please describe your project and email artwork separately.`;
    if(window.CowtownUploads?.enabled()){
      details=details.replace(/Please describe your project and email artwork separately./,'Please describe your project.');
      details=details.replace(/File selected locally only; artwork and mask must be emailed separately./,'Production white separations remain subject to manual review.');
      details+='\n'+(uploaded.length?uploaded.map(r=>r.role+' upload reference: '+r.id+' ('+r.filename+')').join('\n'):'Preview/sample artwork: '+state.imageName+'; confirm artwork with us.');
    }
    try { sessionStorage.setItem('cowtown-quote',details); } catch(_) {}
    // Stay on the current storefront origin, including Shopify editor previews.
    const destination = new URL(`${storefrontRoot()}pages/contact`, window.location.origin);
    const currentParameters = new URLSearchParams(window.location.search);
    const previewTheme = currentParameters.get('preview_theme_id');
    if (previewTheme) destination.searchParams.set('preview_theme_id', previewTheme);
    destination.searchParams.set('quote', details);
    destination.searchParams.set('handoff', handoffId);
    destination.searchParams.set('product_type',state.productType);
    if(spotWhiteActive()&&state.spotWhiteMode==='setup'){try{sessionStorage.setItem('cowtown-quote-contact',JSON.stringify({name:document.getElementById('SpotWhiteName').value,email:document.getElementById('SpotWhiteEmail').value,phone:document.getElementById('SpotWhitePhone').value,bestTime:document.getElementById('SpotWhiteBestTime').value}));}catch(_){window.alert('Contact details could not be carried over. Please enter them on the contact form.');}}
    window.CowtownAnalytics?.track('quote_started',{product:state.productType,width:state.width,height:state.height,quantity:state.quantity,estimate:estimate.totalPrice});
    window.location.href = destination.pathname + destination.search;
  }  // Update DOM price displays

  function updatePriceDisplay() {
    window.checkArtworkResolution();
    const set=(id,value)=>{const el=document.getElementById(id);if(el)el.innerText=value;};
    if(!state.productType){
      ['UnitPriceDisplay','TotalPriceDisplay','StickyTotalPriceDisplay'].forEach(id=>set(id,'—'));
      set('TotalPriceLabel','Order total');set('StickyTotalPriceLabel','Order total');
      set('ConfigurationSummary','');set('StickyConfigurationSummary','Choose a product type');set('SqInchesDisplay','');
      set('AddToCartText','Choose a product type to continue');syncMenuSelections();
      const addButton=document.getElementById('AddToCartBtn');if(addButton)addButton.disabled=true;
      window.CowtownAnalytics?.configuration({});
      return;
    }
    if(!Number.isFinite(state.width)||!Number.isFinite(state.height)||!Number.isFinite(state.quantity)){
      ['UnitPriceDisplay','TotalPriceDisplay','StickyTotalPriceDisplay'].forEach(id=>set(id,'—'));
      set('TotalPriceLabel','Order total');set('StickyTotalPriceLabel','Order total');
      set('ConfigurationSummary','');set('StickyConfigurationSummary','Choose size & quantity');set('SqInchesDisplay','');
      set('AddToCartText','Choose size & quantity to continue');syncMenuSelections();
      const addButton=document.getElementById('AddToCartBtn');if(addButton)addButton.disabled=true;
      window.CowtownAnalytics?.configuration({product:state.productType});
      return;
    }
    const p=currentEstimate(),signOrBanner=isSignOrBanner();
    const savings=document.getElementById('SavingsBadge');if(savings)savings.hidden=true;
    const known=usesUnitQuantities()||['standard','industrial','holographic','glitter','chrome'].includes(state.material);
    const missingLaminate=!usesUnitQuantities()&&state.laminate==='heavy-duty'&&!(texturedRate()>0);
    set('UnitPriceDisplay',known&&!missingLaminate?'$'+p.unitPrice.toFixed(2):'Quote');
    set('TotalPriceDisplay',known&&!missingLaminate?'$'+p.totalPrice.toFixed(2):'Request a quote');
    set('TotalPriceLabel',requiresQuote()?'Estimated total':'Order total');
    set('StickyTotalPriceDisplay',known&&!missingLaminate?'$'+p.totalPrice.toFixed(2):'Request a quote');
    set('StickyTotalPriceLabel',requiresQuote()?'Estimated total':'Order total');
    if(p.setupFee)set('TotalPriceLabel','Estimate incl. $20 setup');
    set('SavingsBadge',usesUnitQuantities()||requiresQuote()?'':(COPY.savePrefix||'Save')+' '+p.savingsPercent+'%');
    set('CanvasDimensionsBadge',state.width.toFixed(2)+'″ × '+state.height.toFixed(2)+'″');
    set('SqInchesDisplay',state.productType==='banner'?p.linearFeet.toFixed(2)+' linear ft · '+p.across+' across · '+p.runs+' roll run'+(p.runs===1?'':'s')+' · grommets $'+p.hardware.toFixed(2):state.productType==='yard-sign'?'24″ × 18″ landscape · H-stake included · Local Pickup Only':state.productType==='photo-paper'?p.linearFeet.toFixed(2)+' linear ft · '+p.across+' across on '+p.rollWidth.toFixed(0)+'″ media · material $'+p.materialCost.toFixed(2)+'/ft':'Pricing area: '+p.pricingSqInches.toFixed(2)+' sq. in.'+(p.laminateAddon?' · Laminate add-on $'+p.laminateAddon.toFixed(2):''));
    if(state.productType==='sticker-sheet')set('TotalPriceLabel','Estimate — file review required');
    set('AddToCartText',requiresQuote()?(state.productType==='sticker-sheet'?'Request a Sticker Sheet Quote':state.productType==='yard-sign'?'Request Local Pickup Order':'Request a Quote'):(COPY.addToCartLabel||'Add to Order Box')+' — $'+p.totalPrice.toFixed(2));
    set('ConfigurationSummary',document.querySelector('.config-format-btn[data-format="'+state.productType+'"]')?.dataset.formatName+' · '+state.width.toFixed(2)+'″ × '+state.height.toFixed(2)+'″ · Qty '+state.quantity+(['die-cut','kiss-cut','sticker-sheet'].includes(state.productType)?' · '+(document.getElementById('MaterialSelect')?.selectedOptions?.[0]?.text||state.material)+' · '+state.laminate:''));
    set('StickyConfigurationSummary',state.width.toFixed(2)+'″ × '+state.height.toFixed(2)+'″ · Qty '+state.quantity);
    syncMenuSelections();
    const cartButton=document.getElementById('AddToCartBtn');
    if(!state.productType){
      if(cartButton)cartButton.disabled=true;
      set('AddToCartText','Choose a product type to continue');
    } else if(cartButton) cartButton.disabled=false;
    const bulk=document.getElementById('B2BPrompt');if(bulk)bulk.hidden=!usesUnitQuantities();
    set('B2BButton',state.productType==='yard-sign'?'Need 20+ signs? Request a B2B Wholesale Quote':state.productType==='photo-paper'?'Need 20+ prints? Request a B2B Wholesale Quote':'Need 20+ banners? Request a B2B Wholesale Quote');
    window.CowtownAnalytics?.configuration({product:state.productType,material:state.materialTouched?state.material:'',laminate:state.laminateTouched?state.laminate:'',width:state.width,height:state.height,quantity:state.quantity,borderColor:state.bleedTouched?state.borderColor:'',borderWidth:state.bleedTouched?state.borderWidth:'',cutShape:state.cutShapeTouched?state.cutShape:'',estimate:p.totalPrice,unitPrice:p.unitPrice,requiresQuote:requiresQuote()});
  }
  function syncDimensionControls() {
    const banner=state.productType==='banner',photo=state.productType==='photo-paper',sign=state.productType==='yard-sign';
    for(const axis of ['Width','Height'])for(const kind of ['Range','Number']){
      const input=document.getElementById(axis+kind+'Input');if(!input)continue;
      input.disabled=sign;input.min=banner?6:1;input.max=banner?(axis==='Width'?240:48):photo?(axis==='Width'?240:28):48;input.step=banner?6:0.25;
    }
    const note=document.getElementById('DimensionLimitsNote');if(note)note.innerText=banner?'Banner width: 6″–240″ in 6″ steps. Height: 6″–48″ in 6″ steps. Artwork fits without stretching.':photo?'Photo-print length: 1″–240″. Media width: 1″–28″. Multiple prints are nested across the 28″ roll.':sign?'Fixed 24″ × 18″ landscape sign. H-stake included. Local Pickup Only.':state.productType==='die-cut'&&state.cutShape==='circle'?'Round die-cut: width and height are the same diameter. Artwork corners may be cropped by the circular cut.':'Finished dimensions: 1″–48″. Edited dimension uses quarter-inch steps; proportional dimension is calculated.';
    const custom=document.getElementById('CustomUnitQuantity');if(custom)custom.value=state.quantity;
    const quantityLabel=document.getElementById('QuantityHeading');if(quantityLabel)quantityLabel.innerText=usesUnitQuantities()?'Quantity':'Quantity & Volume Pricing';
    const hasDimensions=Number.isFinite(state.width)&&Number.isFinite(state.height);
    if(!hasDimensions&&!isSignOrBanner()){
      const widthNumber=document.getElementById('WidthNumberInput');
      const heightNumber=document.getElementById('HeightNumberInput');
      const widthDisplay=document.getElementById('WidthDisplayVal');
      const heightDisplay=document.getElementById('HeightDisplayVal');
      if(widthNumber)widthNumber.value='';
      if(heightNumber)heightNumber.value='';
      if(widthDisplay)widthDisplay.innerText='—';
      if(heightDisplay)heightDisplay.innerText='—';
    }
  }
  window.selectUnitQuantity=function(value){
    const input=document.getElementById('CustomUnitQuantity');
    if(value==='custom'){if(input){input.hidden=false;input.focus();}return;}
    const quantity=Number(value);if(!Number.isSafeInteger(quantity)||quantity<1){if(input){input.setCustomValidity('Enter a positive whole number.');input.reportValidity();}return;}
    if(input){input.setCustomValidity('');input.value=quantity;}
    state.quantity=quantity;updatePriceDisplay();
  };
  function borderInches() {
    if(!['die-cut','kiss-cut'].includes(state.productType))return 0;
    if(!state.borderColor||!state.borderWidth)return 0;
    return selectedBleedWidth();
  }
  function artworkPrintSize() {
    if(!Number.isFinite(state.width)||!Number.isFinite(state.height))return {width:0,height:0};
    // Configured dimensions describe the finished sticker, so artwork keeps
    // scaling with that size. Pixel dimensions still drive the PPI warning.
    const inset=['die-cut','kiss-cut'].includes(state.productType)?borderInches()*2:0;
    let width=Math.max(.1,state.width-inset),height=Math.max(.1,state.height-inset);
    if(state.imageObj){
      const ratio=Number.isFinite(state.artworkRatio)&&state.artworkRatio>0?state.artworkRatio:state.imageObj.naturalWidth/state.imageObj.naturalHeight;
      if(width/height>ratio)width=height*ratio;
      else height=width/ratio;
    }
    return {width,height};
  }
  function drawRotatedArtwork(context,image,x,y,width,height) {
    const rotation=((state.artworkRotation%360)+360)%360;
    context.save();
    context.translate(x+width/2,y+height/2);
    context.rotate(rotation*Math.PI/180);
    if(rotation===90||rotation===270)context.drawImage(image,-height/2,-width/2,height,width);
    else context.drawImage(image,-width/2,-height/2,width,height);
    context.restore();
  }
  function rotatedSourceSize() {
    if(!state.imageObj)return {width:0,height:0};
    const quarterTurn=Math.abs(state.artworkRotation%180)===90;
    return quarterTurn?{width:state.imageObj.naturalHeight,height:state.imageObj.naturalWidth}:{width:state.imageObj.naturalWidth,height:state.imageObj.naturalHeight};
  }
  window.updateCutShape = function(value) {
    state.cutShape = state.productType==='die-cut'&&['artwork','rectangle','rounded','circle'].includes(value)?value:'artwork';
    state.cutShapeTouched=true;
    syncProductOptions();
    if(Number.isFinite(state.width))window.updateStickerDimensions(state.width,null);
    else {updatePriceDisplay();renderCanvas();}
  };
  window.continueFromCutOptions=function(){
    const bleedSection=document.getElementById('BleedOptions');
    const dimensionsSection=document.getElementById('ConfiguratorDimensionsSection');
    if(bleedSection)bleedSection.open=false;
    if(dimensionsSection)dimensionsSection.open=true;
  };

  // Fill enclosed transparent holes: the preview represents an external cut only.
  function exteriorMask(alpha, width, height) {
    const size=width*height, outside=new Uint8Array(size), queue=new Int32Array(size);
    let head=0,tail=0;
    function add(i) { if(!outside[i] && alpha[i]<128) { outside[i]=1; queue[tail++]=i; } }
    for(let x=0;x<width;x++){add(x);add((height-1)*width+x);}
    for(let y=0;y<height;y++){add(y*width);add(y*width+width-1);}
    while(head<tail){const i=queue[head++], x=i%width,y=Math.floor(i/width);
      if(x>0)add(i-1);if(x<width-1)add(i+1);if(y>0)add(i-width);if(y<height-1)add(i+width);
    }
    return Uint8Array.from(outside,v=>v?0:1);
  }
  // Chamfer distance expansion gives the on-screen contour smooth outer joins.
  function expandMask(mask,w,h,radius) {
    const d=Float32Array.from(mask,v=>v?0:1e6), diagonal=Math.SQRT2;
    for(let y=0;y<h;y++)for(let x=0;x<w;x++){const i=y*w+x;
      if(x)d[i]=Math.min(d[i],d[i-1]+1);
      if(y)d[i]=Math.min(d[i],d[i-w]+1);
      if(x&&y)d[i]=Math.min(d[i],d[i-w-1]+diagonal);
      if(y&&x<w-1)d[i]=Math.min(d[i],d[i-w+1]+diagonal);
    }
    for(let y=h-1;y>=0;y--)for(let x=w-1;x>=0;x--){const i=y*w+x;
      if(x<w-1)d[i]=Math.min(d[i],d[i+1]+1);
      if(y<h-1)d[i]=Math.min(d[i],d[i+w]+1);
      if(x<w-1&&y<h-1)d[i]=Math.min(d[i],d[i+w+1]+diagonal);
      if(x&&y<h-1)d[i]=Math.min(d[i],d[i+w-1]+diagonal);
    }
    return Uint8Array.from(d,v=>v<=radius?1:0);
  }
  function removeTinyComponents(mask,w,h,minimumArea) {
    if(minimumArea<=1)return mask;
    const result=mask.slice(),visited=new Uint8Array(mask.length),queue=new Int32Array(mask.length);
    for(let start=0;start<mask.length;start++){
      if(!mask[start]||visited[start])continue;
      let head=0,tail=0;queue[tail++]=start;visited[start]=1;
      while(head<tail){
        const index=queue[head++],x=index%w,y=Math.floor(index/w);
        if(x){const next=index-1;if(mask[next]&&!visited[next]){visited[next]=1;queue[tail++]=next;}}
        if(x<w-1){const next=index+1;if(mask[next]&&!visited[next]){visited[next]=1;queue[tail++]=next;}}
        if(y){const next=index-w;if(mask[next]&&!visited[next]){visited[next]=1;queue[tail++]=next;}}
        if(y<h-1){const next=index+w;if(mask[next]&&!visited[next]){visited[next]=1;queue[tail++]=next;}}
      }
      if(tail<minimumArea)for(let i=0;i<tail;i++)result[queue[i]]=0;
    }
    return result;
  }
  function buildSmoothOuterMask(alpha,w,h,radius,key,minimumFeatureDiameter=0,fillExpandedHoles=true) {
    if(contourMaskCache.key===key&&contourMaskCache.mask)return contourMaskCache;
    let artworkMask=Uint8Array.from(alpha,value=>value>=128?1:0);
    if(minimumFeatureDiameter>0){
      const minimumArea=Math.PI*Math.pow(minimumFeatureDiameter/2,2);
      artworkMask=removeTinyComponents(artworkMask,w,h,minimumArea);
    }
    const cleanedAlpha=Uint8Array.from(artworkMask,value=>value?255:0);
    let mask=expandMask(exteriorMask(cleanedAlpha,w,h),w,h,Math.max(0,radius));
    // Expansion can bridge nearby artwork components. Fill again afterward so
    // every newly enclosed gap becomes part of one printable outer silhouette.
    if(fillExpandedHoles){const expandedAlpha=Uint8Array.from(mask,value=>value?255:0);mask=exteriorMask(expandedAlpha,w,h);}

    // Anti-alias and gently smooth pixel stair-steps without changing the broad
    // silhouette. This is a preview approximation; prepress still owns the path.
    const source=document.createElement('canvas'),softened=document.createElement('canvas');
    source.width=softened.width=w;source.height=softened.height=h;
    const sourceContext=source.getContext('2d'),sourceData=sourceContext.createImageData(w,h);
    for(let i=0;i<mask.length;i++)if(mask[i])sourceData.data[i*4+3]=255;
    sourceContext.putImageData(sourceData,0,0);
    const softenedContext=softened.getContext('2d',{willReadFrequently:true});
    softenedContext.filter='blur(1.1px)';softenedContext.drawImage(source,0,0);
    const softenedPixels=softenedContext.getImageData(0,0,w,h).data;
    const opacity=new Uint8ClampedArray(mask.length),smoothMask=new Uint8Array(mask.length);
    for(let i=0;i<mask.length;i++){const value=softenedPixels[i*4+3];opacity[i]=value;smoothMask[i]=value>=112?1:0;}
    const smoothAlpha=Uint8Array.from(smoothMask,value=>value?255:0);
    const closedMask=fillExpandedHoles?exteriorMask(smoothAlpha,w,h):smoothMask;
    for(let i=0;i<closedMask.length;i++)if(closedMask[i])opacity[i]=Math.max(opacity[i],240);
    contourMaskCache={key,mask:closedMask,opacity};return contourMaskCache;
  }
  function buildV316KissCutMask(alpha,w,h,radius,key) {
    if(contourMaskCache.key===key&&contourMaskCache.mask)return contourMaskCache;
    // Trace submitted transparency directly so meaningful counters inside
    // letters such as B, R, and O remain internal cuts. Expansion naturally
    // closes only holes too small for the selected Kiss-Cut bleed.
    const artworkMask=Uint8Array.from(alpha,value=>value>=128?1:0);
    const mask=expandMask(artworkMask,w,h,Math.max(0,radius)),opacity=new Uint8ClampedArray(mask.length);
    for(let i=0;i<mask.length;i++)if(mask[i])opacity[i]=255;
    contourMaskCache={key,mask,opacity};return contourMaskCache;
  }
  function drawSoftCutline(ctx,edge) {
    const layer=document.createElement('canvas');layer.width=edge.width;layer.height=edge.height;
    layer.getContext('2d').putImageData(edge,0,0);
    ctx.save();ctx.filter='blur(.45px)';ctx.drawImage(layer,0,0);ctx.restore();
  }
  function renderUnboundedArtworkPreview(ctx) {
    if(!state.imageObj)return;
    // Before a product/size exists, show the uploaded file at a natural canvas
    // scale. This keeps the upload interaction reassuring instead of leaving an
    // empty canvas while the customer makes the remaining selections.
    const source=rotatedSourceSize(),scale=Math.min(1,430/Math.max(source.width,source.height));
    const width=Math.max(1,source.width*scale);
    const height=Math.max(1,source.height*scale);
    const x=(600-width)/2,y=(600-height)/2;
    if(!['die-cut','kiss-cut'].includes(state.productType)||!state.borderColor||!state.borderWidth){drawRotatedArtwork(ctx,state.imageObj,x,y,width,height);return;}
    const artwork=document.createElement('canvas');artwork.width=600;artwork.height=600;
    const artworkContext=artwork.getContext('2d',{willReadFrequently:true});drawRotatedArtwork(artworkContext,state.imageObj,x,y,width,height);
    try{
      const rgba=artworkContext.getImageData(0,0,600,600).data;
      const alpha=new Uint8Array(360000);for(let i=0;i<alpha.length;i++)alpha[i]=rgba[i*4+3];
      // Until a finished size is chosen, calculate the visible bleed from the
      // file's natural 300-PPI preview size rather than an invented sticker size.
      const bleedPixels=Math.max(1,borderInches()*300*scale);
      const key=['unbounded',state.productType,artworkRevision,state.artworkRotation,x,y,width,height,state.borderStyle].join('|');
      const contour=state.productType==='kiss-cut'?buildV316KissCutMask(alpha,600,600,bleedPixels,key):buildSmoothOuterMask(alpha,600,600,bleedPixels,key,0,true);
      const mask=contour.mask;
      const bleed=ctx.createImageData(600,600),edge=ctx.createImageData(600,600);
      const shade=state.borderColor==='black'?0:255,dashPhase=Math.floor(Date.now()/110)%18;
      for(let i=0;i<mask.length;i++){
        const offset=i*4;
        if(contour.opacity[i]){bleed.data[offset]=shade;bleed.data[offset+1]=shade;bleed.data[offset+2]=shade;bleed.data[offset+3]=contour.opacity[i];}
        if(!mask[i])continue;
        const px=i%600,py=Math.floor(i/600),edgePixel=!px||px===599||!py||py===599||!mask[i-1]||!mask[i+1]||!mask[i-600]||!mask[i+600];
        if(edgePixel&&(px+py+dashPhase)%18<10){edge.data[offset]=245;edge.data[offset+1]=158;edge.data[offset+2]=11;edge.data[offset+3]=255;}
      }
      if(borderInches())ctx.putImageData(bleed,0,0);
      ctx.drawImage(artwork,0,0);drawSoftCutline(ctx,edge);
    }catch(_){drawRotatedArtwork(ctx,state.imageObj,x,y,width,height);}
  }
  function renderCanvas() {
    const canvas=document.getElementById('ArtworkCanvas');
    if(!canvas)return;
    const emptyState=document.getElementById('ArtworkEmptyState');
    if(emptyState) emptyState.hidden=Boolean(state.imageObj);
    const replaceControl=document.getElementById('ArtworkReplaceControl');
    if(replaceControl) replaceControl.hidden=!state.imageObj;
    const ctx=canvas.getContext('2d');if(!ctx)return;
    canvas.width=600;canvas.height=600;
    if(!state.productType||!Number.isFinite(state.width)||!Number.isFinite(state.height)){
      renderUnboundedArtworkPreview(ctx);
      return;
    }
    const note=document.getElementById('CutPreviewNote');
    if(note)note.innerText='Preview only. Final cut path, bleed, and small details require artwork review.';
    if(state.productType==='sticker-sheet') {
      ctx.fillStyle='#cbd5e1';ctx.font='18px sans-serif';ctx.textAlign='center';
      ctx.fillText('Sticker sheet layout requires artwork review',300,290);
      ctx.font='15px sans-serif';ctx.fillText('Selected dimensions describe the entire sheet.',300,320);
      return;
    }
    const ppi=Math.min(430/state.width,430/state.height)*Math.min(state.zoom,1.25);
    const w=state.width*ppi,h=state.height*ppi,x=(600-w)/2,y=(600-h)/2;
    if(state.productType==='banner') {
      ctx.fillStyle='#ffffff';ctx.fillRect(x,y,w,h);
      if(state.imageObj) { const fit=artworkPrintSize();drawRotatedArtwork(ctx,state.imageObj,(600-fit.width*ppi)/2,(600-fit.height*ppi)/2,fit.width*ppi,fit.height*ppi); }
      drawBannerGrommets(ctx,x,y,ppi);return;
    }
    if(!state.imageObj&&['yard-sign','photo-paper'].includes(state.productType)){ctx.fillStyle='white';ctx.fillRect(x,y,w,h);}
    if(!state.imageObj)return;
    let print=artworkPrintSize();
    if(state.productType==='die-cut'&&state.cutShape==='circle'){
      const usableDiameter=Math.max(.1,Math.min(state.width,state.height)-2*borderInches());
      const fit=Math.min(1,usableDiameter/Math.hypot(print.width,print.height));
      print={width:print.width*fit,height:print.height*fit};
    }else if(state.productType==='die-cut'&&['rectangle','rounded'].includes(state.cutShape)){
      const usableWidth=Math.max(.1,state.width-2*borderInches()),usableHeight=Math.max(.1,state.height-2*borderInches());
      const fit=Math.min(1,usableWidth/print.width,usableHeight/print.height);
      print={width:print.width*fit,height:print.height*fit};
    }
    const iw=print.width*ppi,ih=print.height*ppi,ix=(600-iw)/2,iy=(600-ih)/2;
    const sticker=['die-cut','kiss-cut'].includes(state.productType);
    const off=document.createElement('canvas');off.width=600;off.height=600;
    const oc=off.getContext('2d',{willReadFrequently:true});
    drawRotatedArtwork(oc,state.imageObj,ix,iy,iw,ih);
    if(spotWhiteActive()&&state.spotWhiteMode==='upload'&&state.maskImage&&document.getElementById('SpotWhiteOverlay')?.checked){oc.save();oc.globalAlpha=0.45;drawRotatedArtwork(oc,state.maskImage,ix,iy,iw,ih);oc.restore();}
    if(!sticker){if(['yard-sign','photo-paper'].includes(state.productType)){ctx.fillStyle='white';ctx.fillRect(x,y,w,h);}ctx.drawImage(off,0,0);return;}
    if(state.cutShape==='artwork') {
      try {
        const rgba=oc.getImageData(0,0,600,600).data;
        const alpha=new Uint8Array(360000);
        for(let i=0;i<alpha.length;i++)alpha[i]=rgba[i*4+3];
        // Once a finished size exists, keep rendering the selected bleed at its
        // actual inch value. The moving gold dash follows the outside trim edge.
        const key=['sized',state.productType,artworkRevision,state.artworkRotation,ix,iy,iw,ih,state.borderStyle].join('|');
        // Map inches through the actual rendered finished size. For example,
        // 0.08 inch on a 6-inch sticker occupies 0.08/6 of its preview width.
        const physicalPixelsPerInch=Math.min(w/state.width,h/state.height);
        const bleedPixels=borderInches()*physicalPixelsPerInch;
        const contour=state.productType==='kiss-cut'?buildV316KissCutMask(alpha,600,600,bleedPixels,key):buildSmoothOuterMask(alpha,600,600,bleedPixels,key,0,true);
        const mask=contour.mask;
        const bleed=ctx.createImageData(600,600),edge=ctx.createImageData(600,600);
        const shade=state.borderColor==='black'?0:255;
        const dashPhase=Math.floor(Date.now()/110)%18;
        for(let i=0;i<mask.length;i++){
          const o=i*4;
          if(contour.opacity[i]){bleed.data[o]=shade;bleed.data[o+1]=shade;bleed.data[o+2]=shade;bleed.data[o+3]=contour.opacity[i];}
          if(!mask[i])continue;
          const px=i%600,py=Math.floor(i/600);
          const edgePixel=!px||px===599||!py||py===599||!mask[i-1]||!mask[i+1]||!mask[i-600]||!mask[i+600];
          if(edgePixel&&(px+py+dashPhase)%18<10){
            edge.data[o]=245;edge.data[o+1]=158;edge.data[o+2]=11;edge.data[o+3]=255;
          }
        }
        if(borderInches())ctx.putImageData(bleed,0,0);
        ctx.drawImage(off,0,0);
        drawSoftCutline(ctx,edge);
        if(note)note.innerText='Moving gold dash: approximate trim edge traced from image transparency. Solid backgrounds and production cut paths require review.';
      } catch(error) {
        ctx.drawImage(off,0,0);
        if(note)note.innerText='Contour unavailable for this image. Upload a transparent PNG or request artwork review. No cut path has been verified.';
      }
    } else {
      const radius=state.cutShape==='rounded' ? Math.min(0.125*ppi,w/2,h/2) : 0;
      ctx.beginPath();if(state.cutShape==='circle'){ctx.arc(300,300,w/2,0,Math.PI*2);}else{ctx.roundRect(x,y,w,h,radius);}
      ctx.save();ctx.clip();
      if(borderInches()){ctx.fillStyle=state.borderColor==='black'?'#000000':'#ffffff';ctx.fillRect(x,y,w,h);}
      ctx.drawImage(off,0,0);ctx.restore();
      ctx.beginPath();if(state.cutShape==='circle'){ctx.arc(300,300,w/2,0,Math.PI*2);}else{ctx.roundRect(x,y,w,h,radius);}ctx.strokeStyle='#f59e0b';ctx.lineWidth=1.5;ctx.setLineDash([8,6]);ctx.lineDashOffset=-(Date.now()/90);ctx.stroke();ctx.setLineDash([]);
    }
  }

  // Global functions exposed to window
  window.selectConfigProduct = function (formatId) {
    const legacy={holographic:['die-cut','holographic'],'holographic-kiss-cut':['kiss-cut','holographic'],'bumper-decal':['die-cut','industrial'],'heavy-duty-kiss-cut':['kiss-cut','industrial']};
    if(legacy[formatId]){state.material=legacy[formatId][1];formatId=legacy[formatId][0];}
    if(!['die-cut','kiss-cut','sticker-sheet','banner','yard-sign','photo-paper'].includes(formatId))return;
    if(state.productType===formatId){
      const choicesAreCompact=[...document.querySelectorAll('.config-format-btn')].some(button=>button.classList.contains('is-unselected'));
      syncFormatChoices(choicesAreCompact?null:formatId);
      const selectedProductSection=document.getElementById('ConfiguratorProductSection');
      if(selectedProductSection)selectedProductSection.open=true;
      return;
    }
    const previousProduct=state.productType;
    state.productType = formatId;
    if(previousProduct!==formatId){
      const defaultBorderWidth=formatId==='kiss-cut'?'thin':'medium';
      state.materialTouched=false;state.laminateTouched=false;state.bleedTouched=false;state.borderStyle='white-'+defaultBorderWidth;state.borderColor='white';state.borderWidth=defaultBorderWidth;state.cutShapeTouched=false;
    }
    if(formatId==='kiss-cut'){state.cutShape='artwork';}
    if(previousProduct!==formatId){
      if(formatId==='yard-sign'){state.width=24;state.height=18;state.quantity=1;}
      else if(formatId==='banner'){state.width=36;state.height=24;state.quantity=1;}
      else if(formatId==='photo-paper'){state.width=24;state.height=18;state.quantity=1;}
      else if(['die-cut','kiss-cut','sticker-sheet'].includes(formatId)){
        state.width=3;state.height=state.imageObj?Math.max(1,Math.min(48,3/state.artworkRatio)):3;state.quantity=100;
      }
      else {state.width=null;state.height=null;state.quantity=null;}
    }
    syncDimensionControls();
    syncProductOptions();
    const productSection=document.getElementById('ConfiguratorProductSection');
    const materialSection=document.getElementById('ConfiguratorMaterialSection');
    const finishSection=document.getElementById('FinishOptions');
    if(productSection) productSection.open=true;
    if(materialSection && ['die-cut','kiss-cut','sticker-sheet'].includes(formatId)) materialSection.open=true;
    if(finishSection) finishSection.open=false;
    document.querySelectorAll('.config-format-btn').forEach((btn) => {
      if (btn.dataset.format === formatId) {
        btn.className = 'config-format-btn p-3 rounded-xl border text-left transition-all cursor-pointer bg-amber-500/10 border-amber-500 text-slate-100';
      } else {
        btn.className = 'config-format-btn p-3 rounded-xl border border-slate-800 bg-slate-900 text-slate-300 hover:border-slate-700 text-left transition-all cursor-pointer';
      }
    });
    syncFormatChoices(formatId);

    const selectedButton = document.querySelector(`.config-format-btn[data-format="${formatId}"]`);
    const noticeText = document.getElementById('FormatNoticeText');
    if (noticeText && selectedButton && selectedButton.dataset.formatDescription) {
      noticeText.innerText = selectedButton.dataset.formatDescription || '';
    }

    if(Number.isFinite(state.width)&&Number.isFinite(state.height))window.updateStickerDimensions(state.width, state.height);
    else {updatePriceDisplay();renderCanvas();}
  };

  window.updateStickerDimensions = function (w, h) {
    const validW = w !== null && Number.isFinite(w);
    const validH = h !== null && Number.isFinite(h);
    const snap = value => Math.round(value * 4) / 4;
    if(!validW&&!validH&&!isSignOrBanner()){
      syncDimensionControls();
      updatePriceDisplay();
      renderCanvas();
      return;
    }
    if(state.productType==='yard-sign'){state.width=24;state.height=18;}
    else if(state.productType==='banner'){
      if(validW)state.width=Math.min(240,Math.max(6,Math.round(w/6)*6));
      if(validH)state.height=Math.min(48,Math.max(6,Math.round(h/6)*6));
    }
    else if(state.productType==='photo-paper'){
      if(state.lockProportions&&state.imageObj){
        const ratio=state.artworkRatio,editingHeight=!validW&&validH;
        let width=editingHeight?h*ratio:w,height=editingHeight?h:w/ratio;
        const fit=Math.min(1,240/width,28/height);
        state.width=Math.max(1,snap(width*fit));state.height=Math.max(1,snap(height*fit));
      }else{
        if(validW)state.width=Math.min(240,Math.max(1,snap(w)));
        if(validH)state.height=Math.min(28,Math.max(1,snap(h)));
      }
    }
    else if(state.productType==='die-cut'&&state.cutShape==='circle'){const diameter=Math.min(48,Math.max(1,snap(validW?w:validH?h:state.width)));state.width=diameter;state.height=diameter;}
    else if (state.lockProportions && state.productType !== 'sticker-sheet') {
      const ratio = state.artworkRatio;
      const editingHeight = !validW && validH;
      const factor = editingHeight ? 1 / ratio : ratio;
      const inset = borderInches() * 2;
      const minimum = Math.ceil(Math.max(1, (1-inset)*factor+inset) * 4) / 4;
      const maximum = Math.floor(Math.min(48, (48-inset)*factor+inset) * 4) / 4;
      if (minimum <= maximum) {
        const requested = editingHeight ? h : validW ? w : state.width;
        const selected = Math.min(maximum, Math.max(minimum, snap(requested)));
        state.width = editingHeight ? (selected-inset) * ratio+inset : selected;
        state.height = editingHeight ? selected : (selected-inset) / ratio+inset;
      }
    } else {
      if (validW) state.width = Math.min(48, Math.max(1, snap(w)));
      if (validH) state.height = Math.min(48, Math.max(1, snap(h)));
    }
    state.width = Number(state.width.toFixed(2));
    state.height = Number(state.height.toFixed(2));

    syncDimensionControls();
    const wRange = document.getElementById('WidthRangeInput');
    const wNum = document.getElementById('WidthNumberInput');
    const wDisp = document.getElementById('WidthDisplayVal');

    const hRange = document.getElementById('HeightRangeInput');
    const hNum = document.getElementById('HeightNumberInput');
    const hDisp = document.getElementById('HeightDisplayVal');

    if (wRange) wRange.value = state.width;
    if (wNum) wNum.value = state.width.toFixed(2);
    if (wDisp) wDisp.innerText = `${state.width.toFixed(2)}"`;

    if (hRange) hRange.value = state.height;
    if (hNum) hNum.value = state.height.toFixed(2);
    if (hDisp) hDisp.innerText = `${state.height.toFixed(2)}"`;

    updatePriceDisplay();
    renderCanvas();
  };

  window.setDimensionPresets = function (w, h) {
    window.updateStickerDimensions(w, h);
  };

  window.setProportionalSizing = function (checked) {
    state.lockProportions = checked;const input=document.getElementById('LockProportionsInput');if(input)input.checked=checked;
    window.updateStickerDimensions(state.width, null);
  };

  function acceptArtwork(img) {
    clearWhiteMask();
    state.artworkRotation=0;
    state.imageObj = img;
    state.artworkRatio = img.naturalWidth / img.naturalHeight;
    window.updateStickerDimensions(state.width, null);
  }

  window.updateStickerFinish = function (finishVal) {
    unlaminatedAccepted=false;
    state.laminate = finishVal;
    state.laminateTouched=true;
    if(!state.borderColor||!state.borderWidth){
      state.borderColor='white';state.borderWidth=state.productType==='kiss-cut'?'thin':'medium';state.borderStyle='white-'+state.borderWidth;
    }
    state.bleedTouched=true;state.cutShapeTouched=false;
    syncProductOptions();
    const finishSection=document.getElementById('FinishOptions');
    const bleedSection=document.getElementById('BleedOptions');
    const dimensionsSection=document.getElementById('ConfiguratorDimensionsSection');
    if(finishSection)finishSection.open=false;
    if(['die-cut','kiss-cut'].includes(state.productType)){
      if(bleedSection&&!bleedSection.hidden)bleedSection.open=true;
    }else if(state.productType==='sticker-sheet'){
      if(bleedSection)bleedSection.open=false;
      if(dimensionsSection)dimensionsSection.open=false;
      requestAnimationFrame(()=>document.getElementById('StickerSheetCustomerNotes')?.focus());
    }else{
      if(bleedSection)bleedSection.open=false;
      if(dimensionsSection)dimensionsSection.open=true;
    }
    updatePriceDisplay();
    renderCanvas();
  };

  function applyBorderSelection() {
    if(!state.borderColor||!state.borderWidth){syncProductOptions();updatePriceDisplay();renderCanvas();return;}
    state.borderStyle=state.borderColor+'-'+state.borderWidth;
    state.bleedTouched=true;
    syncProductOptions();
    // Keep this panel open so the customer can choose the cut shape and see the
    // temporary, file-relative bleed preview before committing a final size.
    const bleedSection=document.getElementById('BleedOptions');if(bleedSection)bleedSection.open=true;
    updatePriceDisplay();renderCanvas();
  }
  window.updateBorderColor=function(value){if(['white','black'].includes(value))state.borderColor=value;applyBorderSelection();};
  window.updateBorderWidth=function(value){if(['thin','medium','thick'].includes(value))state.borderWidth=value;applyBorderSelection();};
  window.adjustBleedWidth=function(delta){
    const widths=bleedWidthOptions();
    const current=widths.findIndex(option=>option.name===state.borderWidth);
    const direction=Number(delta)<0?-1:1;
    const next=widths[Math.max(0,Math.min(widths.length-1,(current<0?1:current)+direction))];
    window.updateBorderWidth(next.name);
  };
  window.setBleedWidthInches=function(value){
    const widths=bleedWidthOptions();
    const requested=Number(value);
    const closest=widths.reduce((best,option)=>Math.abs(option.value-requested)<Math.abs(best.value-requested)?option:best,widths[0]);
    window.updateBorderWidth(closest.name);
  };
  window.updateBorderStyle=function(value){
    const [color,width]=String(value).split('-');
    if(['white','black'].includes(color)&&['thin','medium','thick'].includes(width)){state.borderColor=color;state.borderWidth=width;}
    applyBorderSelection();
  };

  window.selectStickerQuantity = function (qty) {
    if(usesUnitQuantities()){window.selectUnitQuantity(qty);return;}
    if(![25,50,100,250,500,1000,2500,5000].includes(Number(qty)))return;
    state.quantity = Number(qty);
    document.querySelectorAll('.qty-tier-btn').forEach((btn) => {
      if (parseInt(btn.dataset.qty) === state.quantity) {
        btn.className = 'qty-tier-btn p-2 rounded-xl border text-center transition-all cursor-pointer bg-amber-500 text-slate-950 font-bold border-amber-500';
      } else {
        btn.className = 'qty-tier-btn p-2 rounded-xl border text-center transition-all cursor-pointer bg-slate-900 text-slate-300 border-slate-800 hover:border-slate-700';
      }
    });

    updatePriceDisplay();
  };

  window.adjustCanvasZoom = function (delta) {
    state.zoom = Math.min(1.8, Math.max(0.6, state.zoom + delta));
    const badge = document.getElementById('ZoomLevelBadge');
    if (badge) badge.innerText = `${Math.round(state.zoom * 100)}%`;
    renderCanvas();
  };
  window.rotateArtwork=function(direction){
    if(!state.imageObj)return;
    state.artworkRotation=(state.artworkRotation+(Number(direction)<0?-90:90)+360)%360;
    const source=rotatedSourceSize();
    state.artworkRatio=source.width/source.height;
    if(state.lockProportions&&!isSignOrBanner()&&state.productType!=='sticker-sheet'&&Number.isFinite(state.width))window.updateStickerDimensions(state.width,null);
    else {updatePriceDisplay();renderCanvas();}
  };

  // The cutline is a preview aid, not an export. A modest refresh cadence keeps
  // the dashes in motion without turning the large artwork canvas into a busy loop.
  window.setInterval(()=>{
    if(['die-cut','kiss-cut'].includes(state.productType)&&state.imageObj)renderCanvas();
  },120);
  let originalArtworkFile=null, artworkLoading=false, artworkLoadError=false,cartSubmitting=false;
  const configurationStamp=()=>JSON.stringify([artworkRevision,state.width,state.height,state.quantity,state.productType,state.material,state.laminate,state.borderStyle,state.cutShape,state.artworkRotation,state.sheetNotes,state.spotWhite,state.spotWhiteMode,state.requestProof]);
  async function uploadCurrentArtwork(){
    if(artworkLoadError)throw new Error('Choose a valid image before continuing, or use Custom Orders.');
    if(artworkLoading)throw new Error('Please wait for the artwork preview to finish loading.');
    if(!window.CowtownUploads?.enabled())return [];
    const revision=artworkRevision,mask=state.maskFile;
    const files=[];if(originalArtworkFile)files.push({file:originalArtworkFile,role:'artwork'});
    if(spotWhiteActive()&&state.spotWhiteMode==='upload'&&mask)files.push({file:mask,role:'mask'});
    if(!files.length)return [];
    const result=await window.CowtownUploads.uploadFiles(files);
    if(revision!==artworkRevision||mask!==state.maskFile)throw new Error('Artwork changed while uploading. Please try again.');
    return result;
  }

  window.handleArtworkUpload = function (event) {
    const file = event.target.files && event.target.files[0];
    if (file) {
      if(!file.size||file.size>25*1024*1024){window.alert('Choose an artwork file up to 25 MB. For larger files, email a download link.');event.target.value='';return;}
      originalArtworkFile=null;artworkLoading=true;artworkLoadError=false;
      clearWhiteMask();
      artworkRevision++;
      const revision = artworkRevision;
      state.imageName = file.name;
      const reader = new FileReader();
      reader.onload = function (e) {
        const img = new Image();
        img.onload = function () {
          if (revision !== artworkRevision) return;
          state.artworkSource='upload';acceptArtwork(img);originalArtworkFile=file;artworkLoading=false;
          window.CowtownAnalytics?.track('artwork_ready',{source:'upload',product:state.productType||''});
          renderCanvas();
        };
        img.onerror=()=>{if(revision===artworkRevision){artworkLoading=false;artworkLoadError=true;window.alert('This image could not be previewed. Please choose another file or use Custom Orders.');}};
        img.src = e.target.result;
      };
      reader.onerror=()=>{if(revision===artworkRevision){artworkLoading=false;artworkLoadError=true;}};
      reader.readAsDataURL(file);
    }
  };

  window.loadSampleArtwork = function (type) {
    originalArtworkFile=null;artworkLoading=false;artworkLoadError=false;clearWhiteMask();
    artworkRevision++;
    const revision = artworkRevision;
    const img = new Image();
    img.crossOrigin = 'anonymous';
    const isBull = type === 'bull';
    const url = isBull
      ? COPY.sampleBullUrl || 'https://images.unsplash.com/photo-1572375992501-4b0892d50c69?auto=format&fit=crop&q=80&w=400'
      : COPY.sampleStarUrl || 'https://images.unsplash.com/photo-1550684848-fac1c5b4e853?auto=format&fit=crop&q=80&w=400';
    img.onload = function () {
      if (revision !== artworkRevision) return;
      state.artworkRotation=0;
      state.imageName = isBull ? COPY.sampleBullName || 'Texas Bull Emblem' : COPY.sampleStarName || 'Lone Star Holographic';
      state.artworkSource = 'sample';
      state.imageObj = img;
      state.artworkRatio = img.naturalWidth / img.naturalHeight;
      window.CowtownAnalytics?.track('artwork_ready',{source:'sample',product:state.productType||''});
      const width = Number(isBull ? COPY.sampleBullWidth : COPY.sampleStarWidth) || (isBull ? 3 : 8);
      window.updateStickerDimensions(width, state.lockProportions ? null : width / state.artworkRatio);
    };
    // Register handlers before assigning src, including cached sample images.
    img.src = url;
  };
  window.checkArtworkResolution = function () {
    const status = document.getElementById('ProofDPIStatus');
    const notes = document.getElementById('ProofNotes');
    const cutline = document.getElementById('ProofCutlineStatus');
    if (!status || !notes) return;
    if (cutline) cutline.innerText = 'Not checked — production review required';
    status.className = 'csc-resolution-status text-amber-400 font-bold';
    if(!state.productType){status.innerText='Choose a product type';notes.innerText='';return;}
    if (!state.imageObj) {
      status.innerText = 'Upload artwork to check resolution.';
      notes.innerText = '';
      return;
    }
    if(state.productType === 'sticker-sheet') { status.innerText='Sheet artwork requires review.'; notes.innerText=''; return; }
    const source = state.imageObj.src || '';
    if (/^data:image\/svg\+xml|\.svg(?:[?#]|$)/i.test(source)) {
      status.innerText = 'SVG — resolution not rated';
      notes.innerText = '';
      return;
    }
    const printSize = artworkPrintSize();
    const sourceSize=rotatedSourceSize();
    const ppiX = sourceSize.width / printSize.width;
    const ppiY = sourceSize.height / printSize.height;
    const ppi = Math.min(ppiX, ppiY);
    const target = Math.max(1, Number(COPY.resolutionTarget) || 300);
    const rating = ppi >= target ? 'Resolution OK' : 'Below target';
    status.innerText = `${rating} · ${ppi.toFixed(0)} PPI`;
    status.className = 'csc-resolution-status ' + (ppi >= target ? 'text-emerald-400' : 'text-amber-400') + ' font-bold';
    notes.innerText = '';
  };
  function confirmLowResolutionArtwork() {
    if(!state.imageObj || state.productType==='sticker-sheet') return true;
    const printSize=artworkPrintSize(),sourceSize=rotatedSourceSize(),target=Math.max(1,Number(COPY.resolutionTarget)||300),ppi=Math.min(sourceSize.width/printSize.width,sourceSize.height/printSize.height);
    if(ppi>=target) return true;
    window.CowtownAnalytics?.track('low_resolution_warning',{product:state.productType});
    return window.confirm(`This artwork is approximately ${ppi.toFixed(0)} PPI at the selected finished size, below the ${target} PPI target. It may print soft or pixelated. Continue to checkout anyway?`);
  }
  // Pass 4.3: connect the proven Shopify variant resolver to the
  // existing Cowtown sticker format buttons without changing section schema,
  // templates, routing, or cart architecture.
  const SHOPIFY_PRODUCT_HANDLES = Object.freeze({
    'glitter': 'glitter-die-cut-vinyl-sticker',
    'glitter-kiss-cut': 'glitter-kiss-cut-vinyl-sticker',
    'chrome': 'chrome-die-cut-vinyl-sticker',
    'chrome-kiss-cut': 'chrome-kiss-cut-vinyl-sticker',
    'die-cut': 'standard-die-cut-vinyl-sticker',
    'kiss-cut': 'standard-kiss-cut-vinyl-sticker',
    'holographic': 'holographic-die-cut-vinyl-sticker',
    'holographic-kiss-cut': 'holographic-kiss-cut-vinyl-sticker',
    'bumper-decal': 'heavy-duty-die-cut-vinyl-sticker',
    'heavy-duty-kiss-cut': 'heavy-duty-kiss-cut-vinyl-sticker',
    'sticker-sheet': 'vinyl-sticker-sheet'
  });

  document.addEventListener('shopify:section:load',function(event){if(event.target.querySelector('#configurator'))window.selectConfigProduct(state.productType);});

  const CART_FORMAT_NAMES = Object.freeze({
    'die-cut': 'Standard Die Cut',
    'kiss-cut': 'Standard Kiss Cut',
    'holographic': 'Holographic Die Cut',
    'holographic-kiss-cut': 'Holographic Kiss Cut',
    'bumper-decal': 'Heavy Duty Die Cut',
    'heavy-duty-kiss-cut':'Heavy Duty Kiss Cut',
    'glitter':'Glitter Die Cut','glitter-kiss-cut':'Glitter Kiss Cut',
    'chrome':'Chrome Die Cut','chrome-kiss-cut':'Chrome Kiss Cut',
    'sticker-sheet': 'Custom Sticker Sheet'
  });

  const productOptionMapPromises = new Map();

  function storefrontRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function effectivePricingProductType() {
    if(state.productType==='sticker-sheet')return 'sticker-sheet';
    if(['glitter','chrome'].includes(state.material))return state.material+(state.productType==='kiss-cut'?'-kiss-cut':'');
    if(state.material==='industrial')return state.productType==='kiss-cut'?'heavy-duty-kiss-cut':'bumper-decal';
    // Preserve the estimator behavior already proven in Pass 4.1B:
    // choosing the holographic finish while on a standard die/kiss cut
    // resolves to the corresponding holographic Shopify pricing product.
    if (state.finish === 'holographic') {
      if (state.productType === 'die-cut') return 'holographic';
      if (state.productType === 'kiss-cut') return 'holographic-kiss-cut';
    }
    return state.productType;
  }

  function parseResolverSection(html) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const resolver = doc.querySelector('#CowtownVariantResolverData');
    if (!resolver) {
      throw new Error('Cowtown variant resolver data was not found on the Shopify product section.');
    }

    let optionMap = null;
    const jsonEl = resolver.querySelector('[data-cowtown-option-map]');
    if (jsonEl && jsonEl.textContent.trim()) {
      optionMap = JSON.parse(jsonEl.textContent);
    }

    const variantIdRaw = resolver.dataset.selectedVariantId;
    const variantPriceRaw = resolver.dataset.selectedVariantPrice;
    const availableRaw = resolver.dataset.selectedVariantAvailable;

    return {
      optionMap,
      variantId: variantIdRaw ? Number(variantIdRaw) : null,
      priceCents: variantPriceRaw !== '' && variantPriceRaw != null ? Number(variantPriceRaw) : null,
      available: availableRaw === 'true'
    };
  }

  async function fetchProductSection(productHandle, optionValueIds) {
    const base = `${storefrontRoot()}products/${productHandle}`;
    const url = new URL(base, window.location.origin);
    url.searchParams.set('section_id', 'main-product');
    if (optionValueIds && optionValueIds.length) {
      url.searchParams.set('option_values', optionValueIds.join(','));
    }

    const response = await fetch(url.toString(), {
      method: 'GET',
      headers: { 'Accept': 'text/html' },
      cache: 'no-store'
    });

    if (!response.ok) {
      throw new Error(`Shopify product resolver for "${productHandle}" returned HTTP ${response.status}. Check that this exact handle exists, is Active, and is available to the Online Store.`);
    }

    return parseResolverSection(await response.text());
  }

  async function getProductOptionMap(productHandle) {
    if (!productOptionMapPromises.has(productHandle)) {
      const promise = fetchProductSection(productHandle).then((data) => {
        if (!data.optionMap || !Array.isArray(data.optionMap.options)) {
          throw new Error(`Shopify option-value data is unavailable for "${productHandle}".`);
        }
        return data.optionMap;
      }).catch((err) => {
        productOptionMapPromises.delete(productHandle);
        throw err;
      });
      productOptionMapPromises.set(productHandle, promise);
    }
    return productOptionMapPromises.get(productHandle);
  }

  function findOptionValueId(optionMap, optionName, desiredValue) {
    const option = optionMap.options.find((entry) =>
      String(entry.name || '').trim().toLowerCase() === optionName.toLowerCase()
    );
    if (!option) return null;

    const wanted = String(desiredValue).trim();
    const value = option.values.find((entry) => (String(entry.name).trim() === wanted || (Number.isFinite(Number(entry.name)) && Number(entry.name) === Number(wanted))));
    return value ? value.id : null;
  }

  async function resolveConfiguredVariant(pricing) {
    const effectiveType = effectivePricingProductType();
    const productHandle = pricingHandle(pricing);

    if (!productHandle) {
      throw new Error('This sticker format is not connected to a Shopify pricing product yet.');
    }

    const optionMap = await getProductOptionMap(productHandle);
    const areaValue = pricing.pricingSqInches.toFixed(2);
    const quantityValue = String(state.quantity);

    const areaId = findOptionValueId(optionMap, 'Pricing Area', areaValue);
    const quantityId = findOptionValueId(optionMap, 'Quantity', quantityValue);

    if (!areaId || !quantityId) {
      throw new Error(`No Shopify option match for ${areaValue} sq. in. × ${quantityValue} on "${productHandle}".`);
    }

    // Supply option value IDs in Shopify's product option order.
    const idsByPosition = optionMap.options
      .slice()
      .sort((a, b) => Number(a.position) - Number(b.position))
      .map((option) => {
        const name = String(option.name || '').trim().toLowerCase();
        if (name === 'pricing area') return areaId;
        if (name === 'quantity') return quantityId;
        return null;
      });

    if (idsByPosition.some((id) => !id)) {
      throw new Error(`Unexpected Shopify option structure on "${productHandle}".`);
    }

    const resolved = await fetchProductSection(productHandle, idsByPosition);
    if (!resolved.variantId) {
      throw new Error(`Shopify did not return a variant for ${areaValue} sq. in. × ${quantityValue}.`);
    }
    if (!resolved.available) {
      throw new Error('The matching Shopify variant is currently unavailable.');
    }

    return {
      ...resolved,
      productHandle,
      effectiveType
    };
  }

  function setCartButtonStatus(message, disabled) {
    const btn = document.getElementById('AddToCartBtn');
    const text = document.getElementById('AddToCartText');
    if (btn) btn.disabled = !!disabled;
    if (text) text.innerText = message;
  }

  // Add the real Pricing Area × Quantity variant to Shopify cart.
  // Shopify cart quantity remains 1 because each variant price represents the
  // total price of the configured sticker order.
  window.addConfiguredStickerToCart = async function () {
    if(cartSubmitting)return;
    if(!state.productType){document.getElementById('ConfiguratorProductSection')?.setAttribute('open','');return;}
    if(!await acknowledgeUnlaminated())return;
    if (requiresQuote()) { requestConfigurationQuote(); return; }
    if(!confirmLowResolutionArtwork())return;
    const pricing = calculateStickerPrice(
      state.width,
      state.height,
      state.quantity,
      state.productType,
      state.finish
    );

    const effectiveType = effectivePricingProductType();
    const productHandle = pricingHandle(pricing);

    if (!productHandle) {
      window.alert('This sticker format is still estimator-only and is not connected to checkout yet.');
      return;
    }

    cartSubmitting=true;const stamp=configurationStamp();
    window.CowtownAnalytics?.track('cart_started',{product:state.productType,width:state.width,height:state.height,quantity:state.quantity,estimate:pricing.totalPrice});
    setCartButtonStatus(COPY.addingToCartLabel || 'Adding Custom Order to Cart...', true);

    try {
      const uploaded=await uploadCurrentArtwork();
      const resolved = await resolveConfiguredVariant(pricing);
      if(stamp!==configurationStamp())throw new Error('Your configuration changed while adding to the order. Please try again.');
      const expectedCents = Math.round(pricing.totalPrice * 100);

      // Shopify is authoritative. Refuse checkout if the stored variant price
      // differs from the configurator calculation.
      if (resolved.priceCents !== expectedCents) {
        throw new Error(
          `Price mismatch: configurator $${pricing.totalPrice.toFixed(2)} vs Shopify $${(resolved.priceCents / 100).toFixed(2)}.`
        );
      }

      const selectedButton = document.querySelector(
        `.config-format-btn[data-format="${state.productType}"]`
      );
      const selectedFormatName =
        selectedButton?.dataset.formatName ||
        CART_FORMAT_NAMES[state.productType] ||
        state.productType;

      const checkoutFormatName =
        CART_FORMAT_NAMES[resolved.effectiveType] ||
        selectedFormatName;

      const customerConfiguration = [
        `${state.width.toFixed(2)}″ × ${state.height.toFixed(2)}″`,
        `Qty ${state.quantity}`
      ].join(' · ');

      const payload = {
        items: [
          {
            id: resolved.variantId,
            quantity: 1,
            properties: {
              'Configuration': customerConfiguration,
              '_Sticker Format': checkoutFormatName,
              '_Sticker Quantity': String(state.quantity),
              '_Finished Size': `${state.width.toFixed(2)}" × ${state.height.toFixed(2)}"`,
              '_Actual Area': `${pricing.sqInches.toFixed(2)} sq. in.`,
              '_Pricing Area': `${pricing.pricingSqInches.toFixed(2)} sq. in.`,
              '_Laminate': state.laminate==='none'?'None - unlaminated':state.laminate==='matte'?'Matte':state.laminate==='gloss'?'Gloss':'Heavy-Duty Textured',
              ...(isUnlaminated()?{'_Unlaminated notice':'Acknowledged: disposable/short-term use; reduced durability; transfer tape not recommended.'}:{}),
              '_Vinyl Material': state.material,
              '_Cut Border': borderInches()?(borderInches().toFixed(2)+' inch '+state.borderColor+' contour border'):'No border',
              '_Proofing': state.requestProof?'Customer proof requested; production waits for approval':'No proof requested; staff review required; contact customer if significant issues are found',
              '_Cut Shape': state.cutShape,
              '_Artwork Rotation': `${state.artworkRotation} degrees clockwise`,
              '_Artwork File': state.imageName || 'Artwork to be emailed',
              '_Artwork Delivery': uploaded.length?'Uploaded privately':originalArtworkFile?'Not uploaded - email original artwork with your order number to sales@cowtownstickerco.com':'Theme preview/sample - confirm this artwork before production',
              ...(uploaded.length?{'_Artwork Reference':uploaded.find(r=>r.role==='artwork')?.id||''}:{}),
              '_CSC Analytics Product': state.productType,
              ...(window.CowtownAnalytics?.cartProperties?.()||{})
            }
          }
        ]
      };

      const response = await fetch(`${storefrontRoot()}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(payload)
      });

      if (!response.ok) {
        let detail = '';
        try {
          const errorData = await response.json();
          detail = errorData.description || errorData.message || '';
        } catch (_) {}
        throw new Error(detail || `Shopify cart returned HTTP ${response.status}.`);
      }

      // Keep the already-proven Pass 4.2 behavior: show the full cart after add.
      window.CowtownAnalytics?.track('cart_succeeded',{product:state.productType,width:state.width,height:state.height,quantity:state.quantity,estimate:pricing.totalPrice});
      window.location.assign(`${storefrontRoot()}cart`);
    } catch (err) {
      console.error('Cowtown configured sticker cart:', err);
      window.CowtownAnalytics?.track('cart_failed',{product:state.productType,reason:'shopify_cart'});
      window.alert(`Could not add this sticker configuration to cart.\n\n${err.message}`);
      updatePriceDisplay();
      const btn = document.getElementById('AddToCartBtn');
      if (btn) btn.disabled = false;
    } finally {cartSubmitting=false;}
  };

  window.configureFromProduct=function(value){
    const raw=String(value||''),plain=raw.replace(/-unlaminated$/,'');
    const match=Object.entries(SHOPIFY_PRODUCT_HANDLES).find(([,handle])=>handle===plain);
    const id=match?match[0]:plain;
    const aliases={'die-cut':['die-cut','standard'],'kiss-cut':['kiss-cut','standard'],'holographic':['die-cut','holographic'],'holographic-kiss-cut':['kiss-cut','holographic'],'glitter':['die-cut','glitter'],'glitter-kiss-cut':['kiss-cut','glitter'],'chrome':['die-cut','chrome'],'chrome-kiss-cut':['kiss-cut','chrome'],'bumper-decal':['die-cut','industrial'],'heavy-duty-kiss-cut':['kiss-cut','industrial'],'sticker-sheet':['sticker-sheet','standard'],'grommeted-vinyl-banner':['banner','standard'],'yard-sign-18x24':['yard-sign','standard'],'photo-paper-print':['photo-paper','standard']};
    const choice=aliases[id];if(!choice)return false;
    state.material=choice[1];state.laminate=raw.endsWith('-unlaminated')?'none':'gloss';unlaminatedAccepted=false;window.selectConfigProduct(choice[0]);return true;
  };
  // Initialize on load
  document.addEventListener('DOMContentLoaded', function () {
    const accordionSections=[...document.querySelectorAll('.csc-config-section')];
    accordionSections.forEach(section=>section.addEventListener('toggle',()=>{if(section.open)accordionSections.filter(other=>other!==section).forEach(other=>{other.open=false;});}));
    const productSection=document.getElementById('ConfiguratorProductSection');
    productSection?.addEventListener('toggle',()=>{if(productSection.open)[...document.querySelectorAll('.config-format-btn')].forEach(button=>button.classList.remove('is-unselected'));});
    const materialSection=document.getElementById('ConfiguratorMaterialSection');
    materialSection?.addEventListener('toggle',()=>{if(materialSection.open)[...document.querySelectorAll('.config-material-btn')].forEach(button=>button.classList.remove('is-unselected'));});
    const productSubsections=[...document.querySelectorAll('#ConfiguratorProductSection .csc-subsection')];
    productSubsections.forEach(section=>section.addEventListener('toggle',()=>{
      if(!section.open)return;
      productSubsections.filter(other=>other!==section).forEach(other=>{other.open=false;});
      if(state.productType)syncFormatChoices(state.productType);
      if(section.id!=='ConfiguratorMaterialSection'&&state.materialTouched)syncMaterialChoices(state.material);
    }));
    const entry=new URLSearchParams(window.location.search).get('configure')||COPY.productHandle;
    if(entry)window.configureFromProduct(entry);
    if (document.querySelector(`.config-format-btn[data-format="${state.productType}"]`)) {
      window.selectConfigProduct(state.productType);
    } else {
      syncProductOptions();
      updatePriceDisplay();
      renderCanvas();
    }
  });
})();
